export default __webpack_public_path__ + "static/faq-bg-961298f03f8a2d1b645126b44b724ec7.png";